<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto pt-[3.75vw] pb-[2vw] bg-white">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          学生风采
        </div>
      </div>
    </div>

    <!-- 图片区域 -->
    <div
      class="relative w-[61.46vw] h-[32.03vw] left-1/2 -translate-x-1/2 inline-flex justify-between items-between animation-trigger"
    >
      <!-- 竖版图片区域1 -->
      <div
        class="w-[15vw] h-full inline-flex flex-col justify-between items-center flex-shrink-0 image-container"
      >
        <img
          class="self-stretch h-[21.2vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list1_image1.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list1_image2.png"
        />
      </div>
      <!-- 横版图片区域1 -->
      <div
        class="w-[15vw] h-full inline-flex flex-col justify-between items-center flex-shrink-0 image-container"
      >
        <img
          class="self-stretch h-[10.36vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list2_image1.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list2_image2.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list2_image3.png"
        />
      </div>
      <!-- 横版图片区域2 -->
      <div
        class="w-[15vw] h-full inline-flex flex-col justify-between items-center flex-shrink-0 image-container"
      >
        <img
          class="self-stretch h-[10.36vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list3_image1.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list3_image2.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list3_image3.png"
        />
      </div>
      <!-- 竖版图片区域2 -->
      <div
        class="w-[15vw] h-full inline-flex flex-col justify-between items-center flex-shrink-0 image-container"
      >
        <img
          class="self-stretch h-[21.2vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list4_image1.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module5/p1_list4_image2.png"
        />
      </div>
    </div>
  </div>
</template>

 <script>
export default {
  name: "coursesystem-module6",
  data() {
    return {
      animated: false,
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animated = true;
            // 为每个图片添加随机动画延迟
            document.querySelectorAll(".image-container img").forEach((img) => {
              img.style.setProperty("--delay", `${Math.random() * 0.8}s`);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this.$el.querySelector(".animation-trigger"));
  },
};
</script>

 <style scoped>
.image-container img {
  opacity: 0;
  animation: fadeIn 1s ease-out var(--delay) forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(1.04vw);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>